import { render } from "./TweakPane.vue?vue&type=template&id=39d63ec7"
import script from "./TweakPane.vue?vue&type=script&lang=js"
export * from "./TweakPane.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__